import React from 'react';
import NavigationBar from '../../components/navbar/component'
import Head from '../../components/head/component'
import Image from '../../image/PracticeAreaCover.png'
import {
    Footer
} from '../../components/footer/components'
import {
    PracticeAreaFourCards
} from '../../components/PracticeArea/practiceAreaFourCards'
import { 
    Bg, 
    Title,
    FirstImage,
    ButtonText,
    FirstCard,
    MiniFirstImage,
    HyperLink
 } from './style'
import { 
    Card, 
    CardTitle, 
    CardDescription,
    Circle,
    Arrow
} from '../../components/PracticeArea/style'
import { Box, Flex } from 'reflexbox'
import Pic1 from '../../image/practice_area/1.png';
import Pic2 from '../../image/practice_area/2.png';
import Pic3 from '../../image/practice_area/3.png';
import Pic4 from '../../image/practice_area/4.png';
import Pic5 from '../../image/practice_area/5.png';
import Pic6 from '../../image/practice_area/6.png';
import Pic7 from '../../image/practice_area/7.png';
import Pic8 from '../../image/practice_area/8.png';
import Pic9 from '../../image/practice_area/9.png';
import RightArrow from '../../image/right-arrow.png';
import { useScreenSize } from '../../hooks/useScreenSize';
import { useTranslation } from 'react-i18next';

export const PracticeAreaPage = () => {

    const { t } = useTranslation('common');

    const screenSize = useScreenSize();

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
      }

    return (
        <>
            <NavigationBar />
            <Head 
                imagePath={Image}
                caption='EXCELLENCE IN ADVOCACY INTEGRITY IN PRACTICE'
            />
            <Bg>
                <Card bgColor="#255371" color="#ffffff">
                    {
                        screenSize < 560 ?
                        <div>
                            <div>
                                <MiniFirstImage 
                                    src={Pic1} 
                                    alt="" 
                                />
                            </div>
                            <Flex 
                                flexDirection="row" 
                                marginTop="28px" 
                                marginBottom="16px"
                            >
                            <Flex flexDirection="column" width="100%">
                                <CardTitle>
                                    Bankruptcy & Debt Payment Suspension
                                </CardTitle>
                                <CardDescription>
                                    Sequoia Advocates has extensive experience in handling civil law matters, 
                                    particularly in bankruptcy and debt restructuring. Our team includes licensed
                                    curators and administrators registered with the Indonesian Association of
                                    Curators and Administrators. This expertise allows us to effectively assist clients
                                    with debt restructuring needs.
                                </CardDescription>
                            </Flex>
                            {/* <Flex
                                flexDirection='column' 
                                justifyContent='flex-end'
                            >
                                <Circle  onClick={() => openInNewTab('https://drive.google.com/file/d/1HMu6XVsRZ0zIoVpodvZfAzPMb5__y4kP/view?usp=sharing')}>
                                    <Arrow src={RightArrow} alt ="" />
                                </Circle>
                            </Flex> */}
                            </Flex>
                        </div>
                        :
                        <>
                            <FirstCard>
                                <CardTitle>
                                    {t('secondPageContent.1.title')}
                                </CardTitle>
                                <CardDescription>
                                    {t('secondPageContent.1.description')}
                                </CardDescription>
                            </FirstCard>
                            <Flex
                                flexDirection='column' 
                                width='37%'
                            >
                                <FirstImage 
                                    src={Pic1} 
                                    alt="" 
                                />
                                {/* <Flex
                                    flexDirection='row' 
                                    justifyContent='flex-end'
                                    width='100%'
                                    height='auto'
                                    paddingRight="16px"
                                    paddingBottom="16px"
                                >
                                    <Circle onClick={() => openInNewTab('https://drive.google.com/file/d/1HMu6XVsRZ0zIoVpodvZfAzPMb5__y4kP/view?usp=sharing')}>
                                        <Arrow 
                                            src={RightArrow} 
                                            alt ="" 
                                        />
                                    </Circle>
                                </Flex> */}
                            </Flex>
                        </>
                    }
                </Card>
                <Box marginTop='20px'>
                    <PracticeAreaFourCards 
                        firstCard={{
                            title: t('secondPageContent.2.title'),
                            description: t('secondPageContent.2.description'),
                            image: Pic2,
                            url: 'https://drive.google.com/file/d/1YLk4UuuMZJls_irFEqnZIGse0WO1t5Q3/view?usp=sharing'
                        }}
                        secondCard={{
                            title: t('secondPageContent.3.title'),
                            description: t('secondPageContent.3.description'),
                            image: Pic3,
                            url: 'https://drive.google.com/file/d/1FtMTJGnQAZ3t_y8bm5khxNALWk92jRf5/view?usp=sharing'
                        }}
                        thirdCard={{
                            title: t('secondPageContent.4.title'),
                            description: t('secondPageContent.4.description'),
                            image: Pic4,
                            url: 'https://drive.google.com/file/d/1Za7hQ6IE68bZ_yFU_FVk9Yom7J1ZaiGw/view?usp=sharing'
                        }}
                        forthCard={{
                            title: t('secondPageContent.5.title'),
                            description: t('secondPageContent.5.description'),
                            image: Pic5,
                            url: 'https://drive.google.com/file/d/16c2J7hIIk_S_ZIWgHNGmdijtSd-PvAA9/view?usp=sharing'
                        }}
                        haveArrow={false}
                    />
                </Box>
                <Box marginTop="20px">
                    <PracticeAreaFourCards 
                        firstCard={{
                            title: t('secondPageContent.6.title'),
                            description: t('secondPageContent.6.description'),
                            image: Pic6,
                            url: 'https://drive.google.com/file/d/1csxhXh2cQS0sZK08qbpUt49QAOZTJTcT/view?usp=sharing'
                        }}
                        secondCard={{
                            title: t('secondPageContent.7.title'),
                            description: t('secondPageContent.7.description'),
                            image: Pic7,
                            url: 'https://drive.google.com/file/d/1csxhXh2cQS0sZK08qbpUt49QAOZTJTcT/view?usp=sharing'
                        }}
                        thirdCard={{
                            title: t('secondPageContent.8.title'),
                            description: t('secondPageContent.8.description'),
                            image: Pic8,
                            url: 'https://drive.google.com/file/d/1l2AdAZSxo7ZbOeCG5mqqQPcoYswFSrvt/view?usp=sharing',
                        }}
                        forthCard={{
                            title: t('secondPageContent.9.title'),
                            description: t('secondPageContent.9.description'),
                            image: Pic9,
                            url: 'https://drive.google.com/file/d/1Q2ZK4JnY0e68WDmYn7lMrBoKXBisZSmc/view?usp=sharing'
                        }}
                        haveArrow={false}
                    />
                </Box>
                <Flex 
                    marginTop="80px" 
                    justifyContent="space-between"
                    alignItems="center"
                    flexDirection="column"
                    marginBottom="40px"
                >
                    <Title>
                        {t('download.title')}
                    </Title>
                    <HyperLink
                        href="https://drive.google.com/file/d/1jrHFnvXywBkq_Hxy8-8QaPzDoQKo8PlV/view?usp=sharing" 
                        target="_blank"  
                    >
                        <ButtonText>
                            {t('download.button')}
                        </ButtonText>
                    </HyperLink>
                </Flex>
            </Bg>
            <Footer />
        </>
    )
}